export default function checkIsNumeric(registration, anyDigit = true) {
  const regex = anyDigit ? /^\d+$/ : /^\d{8,9}$/;
  return regex.test(registration);
}
